import * as R from 'ramda';
import { createAction, handleActions } from 'redux-actions';

export const types = {
  syncLocalDatabaseChecked: 'SYNC_LOCAL_DATABASE_CHECKED',
  syncRemoteUserDatabaseSet: 'SYNC_REMOTE_USER_DATABASE_SET',
  syncLocalDataSynced: 'SYNC_LOCAL_DATA_SYNCED',
  syncLocalImagesSynced: 'SYNC_LOCAL_IMAGES_SYNCED',
  syncDeviceError: 'SYNC_DEVICE_ERROR',
  syncDeviceLocalStart: 'SYNC_DEVICE_LOCAL_START',
  syncDeviceLocalProgress: 'SYNC_DEVICE_LOCAL_PROGRESS',
  syncDeviceLocalEnd: 'SYNC_DEVICE_LOCAL_END',
  syncDeviceRemoteStart: 'SYNC_DEVICE_REMOTE_START',
  syncDeviceRemoteProgress: 'SYNC_DEVICE_REMOTE_PROGRESS',
  syncDeviceRemoteEnd: 'SYNC_DEVICE_REMOTE_END',
};

export const syncLocalDatabaseChecked = createAction(types.syncLocalDatabaseChecked);

export const syncRemoteUserDatabaseSet = createAction(types.syncRemoteUserDatabaseSet);

export const syncLocalDataSynced = createAction(types.syncLocalDataSynced);

export const syncLocalImagesSynced = createAction(types.syncLocalImagesSynced);

export const syncDeviceError = createAction(types.syncDeviceError);

export const syncDeviceLocalStart = createAction(types.syncDeviceLocalStart);

export const syncDeviceLocalProgress = createAction(types.syncDeviceLocalProgress);

export const syncDeviceLocalEnd = createAction(types.syncDeviceLocalEnd);

export const syncDeviceRemoteStart = createAction(types.syncDeviceRemoteStart);

export const syncDeviceRemoteProgress = createAction(types.syncDeviceRemoteProgress);

export const syncDeviceRemoteEnd = createAction(types.syncDeviceRemoteEnd);

export const INITIAL_STATE = {
  syncStep: 1,
  error: null,
  localSync: false,
  remoteSync: false,
  localProgress: {},
  remoteProgress: {},
};

export const syncDeviceModalReducer = handleActions(
  {
    [types.syncLocalDatabaseChecked]: state => ({
      ...state,
      syncStep: 2,
      error: '',
    }),
    [types.syncLocalDataSynced]: state => ({
      ...state,
      syncStep: 3,
      error: '',
    }),
    [types.syncLocalImagesSynced]: state => ({
      ...state,
      syncStep: 4,
      error: '',
    }),
    [types.syncDeviceError]: (state, action) => ({
      ...state,
      error: action.payload.error,
    }),
    [types.syncDeviceLocalStart]: state => ({
      ...state,
      localSync: true,
    }),
    [types.syncDeviceLocalProgress]: (state, action) => ({
      ...state,
      localProgress: R.assocPath(
        [action.payload.progress.tableName, action.payload.progress.process],
        action.payload.progress.percentage
      )(state.localProgress),
    }),
    [types.syncDeviceLocalEnd]: state => ({
      ...state,
      localSync: false,
    }),
    [types.syncDeviceRemoteStart]: state => ({
      ...state,
      remoteSync: true,
    }),
    [types.syncDeviceRemoteProgress]: (state, action) => ({
      ...state,
      remoteProgress: R.assocPath(
        [action.payload.progress.tableName, action.payload.progress.process],
        action.payload.progress.percentage
      )(state.remoteProgress),
    }),
    [types.syncDeviceRemoteEnd]: state => ({
      ...state,
      remoteSync: false,
    }),
  },
  INITIAL_STATE
);
